import { render, staticRenderFns } from "./HelpPopup.vue?vue&type=template&id=a5c113fa&scoped=true"
import script from "./HelpPopup.vue?vue&type=script&lang=js"
export * from "./HelpPopup.vue?vue&type=script&lang=js"
import style0 from "./HelpPopup.vue?vue&type=style&index=0&id=a5c113fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c113fa",
  null
  
)

export default component.exports